import React from 'react'
import ServicePage from './ServicePage'
import bgImg from '../../assets/images/ShopifyBg.jpg'
import BrowserTabTitle from '../../components/browserTabTitle'
import { useInView } from 'react-intersection-observer';

const dataArr = [
  {
    subtitle: "Custom Shopify Store Development:",
    title: "We create tailored Shopify stores designed for maximum engagement and conversions.",
  },
  {
    subtitle: "Shopify Store Optimization:",
    title: "Our experts enhance SEO, site speed, and mobile responsiveness to improve user experience.",
  },
  {
    subtitle: "Seamless Integration Services:",
    title: "Connect your store with payment gateways, CRM tools, inventory systems, and third-party apps.",
  },
  {
    subtitle: "Conversion-Focused Design:",
    title: "Our Shopify themes and layouts are optimized for higher sales and retention rates.",
  },
  {
    subtitle: "Ongoing Support & Maintenance:",
    title: "Keep your Shopify store secure, up-to-date, and running smoothly while you focus on growth.",
  },
]
const Shopify = () => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });
  const serviceBgStyle = {
    '--bg-image': `url(${bgImg})`,
  };
  return (
    <section className="serviceBg py100" style={serviceBgStyle}>
      <div className="container">
        <BrowserTabTitle tabTitle={'Shopify Solutions for Businesses in Australia & NZ | Pixel Pace Tech'} metaDescription={`Grow your online store with Pixel Pace’s Shopify development in Australia & NZ. We create user-friendly, SEO-optimized Shopify stores to boost your sales.`} />
        <ServicePage title="Shopify Solutions by Pixel Pace Technologies in Australia & NZ" subTitle='Expert Shopify Development & E-commerce Growth Strategies' detail="At Pixel Pace Technologies, we provide SEO-optimized Shopify solutions for businesses in Australia and New Zealand looking to launch, optimize, and scale their e-commerce stores. Whether you need a custom Shopify store, seamless integrations, or conversion-focused design, our expert team ensures a smooth and high-performing shopping experience for your customers." />
        <div className='pt100' ref={ref}>
          <h3 className={`fs28 mb-4 ${inView ? 'animate__animated animate__fadeInUp' : ''}`}>Why Choose Pixel Pace Technologies for Shopify Development?</h3>
          {
            dataArr.map((data, index) => (
              <div key={index} className={`mb-3 last-of-type:mb-0 ${inView ? 'animate__animated animate__fadeInUp' : ''}`}>
                <p className='fs22 leading-normal'>
                  <b className='mr-1'>
                    {data.subtitle}
                  </b>
                  {data.title}
                </p>
              </div>
            ))
          }
        </div>
      </div>

    </section>
  )
}

export default Shopify
